<template>
  <div>
    <div class="row">
        <div class="card col-md-6">
            <div class="card-content form-group">

                <h4 class="card-title">Reporte de Declaraciones</h4>

                <label>Declaración </label><br>
                <el-select  clearable class="select-default"
                filterable
                name="declaracion"
                placeholder="Declaracion"
                v-model="model.tipo_declaracion">
                    <el-option
                        v-for="option in tiposDeclaracion"
                        class="select-default"
                        :value="option.id"
                        :label="option.tipo_declaracion"
                        :key="option.tipo_declaracion">
                    </el-option>
                </el-select>
                <br>
                <div v-if="getKey('permisos').includes(14)">
                    <label>Dependencia </label><br>
                    <el-select  clearable class="select-default"
                    filterable
                    name="dependencia"
                    placeholder="Dependencia"
                    v-model="model.dependencia_id">
                        <el-option
                            v-for="option in dependencias"
                            :value="option.id"
                            :label="option.valor"
                            :key="option.valor">
                        </el-option>
                    </el-select>
                </div>

                <br>
                <label>Año</label><br>
                <el-select  clearable class="select-default"
                filterable
                name="periodo"
                placeholder="Periodo"
                v-model="model.periodo">
                    <el-option
                        v-for="option in periodos"
                        class="select-default"
                        :value="option.year"
                        :label="option.year"
                        :key="option.year">
                    </el-option>
                </el-select>

            </div>

            <div class="col-md-8 col-md-offset-3">
                <button @click="getDeclarantes" class="btn btn-success btn-wd pull-right">
                        Buscar
                </button>
            </div>
            <br>

        </div>

        <div class="col-md-6">
            <br>
            <circle-chart-card :percentage="avance"
                            :title="dependenciaT"
                            :avance="avanced"
                            :total="totald"
                            :description="model.periodo">
            </circle-chart-card>


        </div>
    </div>
    <div class="card">

        <div class="card-content">
             <h4 class="card-title text-center">Declaraciones Realizadas</h4>
             <div class="row">
            <div class="col-sm-6">
                 <export-excel
                    class   = "btn btn-wd btn-success"
                    :data   = "list_declarantes"
                    :meta   = "meta"
                    :fields = "cumplidos_campos"
                    worksheet = "Cumplidos"
                    name    = "Cumplidos.xls">
                    <span class="btn-label">
                        <i class="fa fa-file-excel"></i>
                    </span>
                    Descargar Reporte
                </export-excel>


            </div>
             <div class="col-sm-6 col-md-6 col-lg-6 pull-right">
                <b-form-group>
                  <b-input-group>
                    <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
            <div class="row">
                <b-table id="tbla_dec" responsive hover :items="list_declarantes" :fields="fields_list" :per-page="perPage" :current-page="currentPage" show-empty :filter="filter" @filtered="onFiltered">
                    <template slot="empty">
                    <h5>No existen registros</h5>
                    </template>
                </b-table>
            </div>
                <div class="col-mb-8 col-8">
                    <b-col md="6" class="my-1">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" first-text="<<" prev-text="<" next-text=">" last-text=">>" aria-controls="tbla_dec"></b-pagination>
                    </b-col>
                </div>
                <div class="col-mb-12 col-12">
                    <p class="category">Mostrando <b>{{from + 1}}</b> a <b>{{to}}</b> de <b>{{total}}</b> registros</p>
                </div>

                    <!-- :fields="fields_list" -->

            <br>
        </div>

    </div>
    <div class="card">

        <div class="card-content">
             <h4 class="card-title text-center">Declaraciones Faltantes</h4>
             <div class="row">
            <div class="col-sm-6">

                 <export-excel
                    class   = "btn btn-wd btn-success"
                    :data   = "list_declarantes2"
                    :meta   = "meta"
                    :fields = "faltantes_campos"
                    worksheet = "Faltantes"
                    name    = "Faltantes.xls">
                    <span class="btn-label">
                        <i class="fa fa-file-excel"></i>
                    </span>
                    Descargar Reporte
                </export-excel>
            </div>
             <div class="col-sm-6 col-md-6 col-lg-6 pull-right">
                <b-form-group>
                  <b-input-group>
                    <b-form-input type="search" v-model="filter2" placeholder="Buscar"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
            <div class="row">
                <b-table id="tbla_dec2" responsive hover :items="list_declarantes2" :fields="fields_list2" :per-page="perPage2" :current-page="currentPage2" show-empty :filter="filter2" @filtered="onFiltered2">
                    <template slot="empty">
                    <h5>No existen registros</h5>
                    </template>
                </b-table>
            </div>
                <div class="col-mb-8 col-8">
                    <b-col md="6" class="my-1">
                    <b-pagination v-model="currentPage2" :total-rows="rows2" :per-page="perPage2" first-text="<<" prev-text="<" next-text=">" last-text=">>" aria-controls="tbla_dec2"></b-pagination>
                    </b-col>
                </div>
                <div class="col-mb-12 col-12">
                    <p class="category">Mostrando <b>{{from2 + 1}}</b> a <b>{{to2}}</b> de <b>{{total2}}</b> registros</p>
                </div>

                    <!-- :fields="fields_list" -->

            <br>
        </div>

    </div>

</div>
</template>
<script>
  import Vue from 'vue'
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import Loading from 'src/components/Dashboard/Layout/LoadingMainPanel.vue'
  import moment from 'moment'
  import excel from 'vue-excel-export'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(excel)

  export default {
    components: {
      StatsCard,
      ChartCard,
      CircleChartCard,
      PPagination
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data () {
      return {
        model:{tipo_declaracion:'',dependencia_id:'',periodo:''},
        dependencias:{},
        rol:'',
        periodos:[],
        dependenciaT:'',
        mostrar:false,
        perPage: 5,
        rows: null,
        currentPage: 1,
        filter:null,
        perPage2: 5,
        rows2: null,
        currentPage2: 1,
        filter2:null,
        tiposDeclaracion:[],
        list_declarantes:[],
        list_declarantes2:[],
        avance:0,
        avanced:'',
        totald:'',
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        pagination2: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        searchQuery2:'',
        cumplidos_campos: {
            'RFC': 'rfc',
            'Nombres': 'nombres',
            'Dependencia': 'dependencia',
            'Cargo' : 'cargo',
            'Fecha' : 'fecha'
        },
        cumplidos_data: [],
        faltantes_campos: {
            'RFC': 'rfc',
            'Nombres': 'nombres',
            'Dependencia': 'dependencia',
            'Cargo' : 'cargo',
            'Correo Personal' : 'correo1',
            'Correo Laboral':'correo2',
            'Teléfono Personal':'tel1',
            'Teléfono Laboral':'tel2'

        },
        faltantes_data: [],
        meta: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],
        fecha:'',
        propsToSearch: ['rfc', 'nombres', 'cargo'],
        propsToSearch2: ['rfc', 'nombres', 'cargo','correo1','correo2','tel1','tel2'],
        fields_list: [{key: "rfc",     label: "RFC" ,tdClass:'cump text-left', thClass:'cump text-center' },
                      {key: "nombres",       label: "Nombres"   ,tdClass:'cump text-left', thClass:'cump text-center' },
                      {key: "dependencia",       label: "Dependencia"   ,tdClass:'cump text-left', thClass:'cump text-center' },
                      {key: "cargo",      label: "Cargo",tdClass:'cump text-left', thClass:'cump text-center' },
                      {key: "fecha",        label: "Fecha"  ,tdClass:'cump text-left', thClass:'cump text-center' },
        ],
         fields_list2: [{key: "rfc",     label: "RFC" ,tdClass:'cump text-left', thClass:'cump text-center' },
                      {key: "nombres",       label: "Nombres"   ,tdClass:'cump text-left', thClass:'cump text-center' },
                      {key: "dependencia",       label: "Dependencia"   ,tdClass:'cump text-left', thClass:'cump text-center' },
                      {key: "cargo",      label: "Cargo",tdClass:'cump text-left', thClass:'cump text-center' },
                      {key: "correo1",        label: "Correo Personal"  ,tdClass:'cump text-left', thClass:'cump text-center' },
                      {key: "correo2",       label: "Correo Laboral"   ,tdClass:'cump text-left', thClass:'cump text-center' },
                      {key: "tel1",      label: "Tel Personal",tdClass:'cump text-left', thClass:'cump text-center' },
                      {key: "tel2",        label: "Tel Laboral"  ,tdClass:'cump text-left', thClass:'cump text-center' }
        ]
      }
    },
    computed: {
      to() {
        let highBound = this.from + this.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.perPage * (this.currentPage - 1);
      },
      total() {
        //console.log(this.list_usuarios.length);
        this.rows = this.list_declarantes.length;

        return this.list_declarantes.length;
      },
      to2() {
        let highBound = this.from2 + this.perPage2;
        if (this.total2 < highBound) {
          highBound = this.total2;
        }
        return highBound;
      },
      from2() {
        return this.perPage2 * (this.currentPage2 - 1);
      },
      total2() {
        //console.log(this.list_usuarios.length);
        this.rows2 = this.list_declarantes2.length;

        return this.list_declarantes2.length;
      }
    },
    created(){
        this.checkPermissions();
        this.getDependencias();
        this.getTipoDeclaracion();
        this.getPeriodos();
        this.rol = this.getKey('role');
        var myDate = new Date();
        var mes = ('0' + (myDate.getMonth() + 1)).slice(-2);
        var dia = ('0' + myDate.getDate()).slice(-2);
        var anio = myDate.getFullYear();
        var fecha = dia + '/' + mes + '/' + anio;
    },
    watch: {
    '$route': 'checkPermissions'
    },
    methods:{
     onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.rows = filteredItems.length
        this.currentPage = 1
      },
      onFiltered2(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.rows2 = filteredItems.length
        this.currentPage2 = 1
      },
        checkPermissions() {
            let permiso = [10,14];
            if(!this.getKey('permisos').some(r=> permiso.includes(r)))
            {
                localStorage.clear();
                this.$router.push('/login');
                this.$router.go();
            }
        },
        getDependencias(){
        var v = this;
        this.$http.get("cat_ente_publico").then(
            response => {
                this.dependencias = response.data.entes_publicos;
            },
            error => {
                this.StepError(error);
            }
        );
        },
        dateFormat: function(date) {
        		return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
        	},
        getTipoDeclaracion(){
        var v = this;
        this.$http.get("tiposDeclaracion").then(
            response => {
            this.tiposDeclaracion = response.data.tipoDeclaracion;
            },
             error => {
            this.StepError(error);
            }
        );
        },
        getPeriodos(){
        var v = this;
        this.$http.get("getPeriodos").then(
            response => {
            this.periodos = response.data.periodos;
            },
             error => {
            this.StepError(error);
            }
        );
        },
        getDeclarantes(){
            if(!this.getKey('permisos').includes(14))//permiso de declaraciones global
                this.model.dependencia_id = this.getKey('ente_publico_id')

            this.$http.post("getDeclarantes",this.model).then(
            response => {
            this.avance = Number((response.data.avance).toFixed(1));
            this.dependenciaT = response.data.entidad[0].valor;
            this.mostrar = true;
            var v = this;
            this.avanced = response.data.total.toString();
            this.totald = response.data.porcentaje.toString();
            v.list_declarantes = [];
             $.each(response.data.declarantes, function(key, value) {
                v.list_declarantes.push({'rfc':value.rfc,
                                        'nombres':value.nombres+' '+value.primer_apellido+' '+value.segundo_apellido,
                                        'dependencia' :v.dependenciaT,
                                        'cargo':value.empleo_cargo_comision,
                                        'fecha': v.dateFormat(value.fecha_dec)
                        });
            });
             v.list_declarantes2 = [];
             $.each(response.data.faltantes, function(key, value) {

                v.list_declarantes2.push({'rfc':value.rfc,
                                        'nombres':value.nombres+' '+value.primer_apellido+' '+value.segundo_apellido,
                                        'dependencia' :v.dependenciaT,
                                        'cargo':value.encargo.empleo_cargo_comision,
                                        'correo1' :value.correo_electronico_personal || '',
                                        'correo2' :value.correo_electronico_laboral || '',
                                        'tel1'      :     value.telefono_particular || '',
                                        'tel2' :value.telefono_laboral || ''
                        });
            });


            },
            error => {
            this.StepError(error);
            }
        );
        }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/Declaraciones2.vue